
{
  "familyId": "STU-LIJN",
  "questions": [
    {
      "id": "STU-LIJN-001",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "line_chart",
      "question": "Bekijk het lijndiagram. In welke maand was de temperatuur het hoogst? Klik op het juiste punt.",
      "context": null,
      "options": ["Januari", "April", "Juli", "Oktober"],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Januari", "value": 3 },
          { "label": "April", "value": 12 },
          { "label": "Juli", "value": 22 },
          { "label": "Oktober", "value": 11 }
        ],
        "correctIndex": 2,
        "xAxisLabel": "Maand",
        "yAxisLabel": "Temperatuur (°C)"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Lijndiagram lezen",
            "content": "Zoek het hoogste punt op de lijn. Juli (22°C) is het hoogste punt — dat is de warmste maand.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "line_chart_highest_point",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Strategie: zoek het hoogste punt op de lijn. Stap 1: Lees de waarden af: Januari (3°C), April (12°C), Juli (22°C), Oktober (11°C). Stap 2: Het hoogste punt is Juli met 22°C.",
        "distractorExplanations": {
          "0": "Januari (3°C) is juist het laagste punt, niet het hoogste.",
          "1": "April (12°C) is niet het hoogste. Juli (22°C) is warmer.",
          "2": "Correct! Juli (22°C) is de warmste maand.",
          "3": "Oktober (11°C) is lager dan Juli (22°C)."
        }
      }
    },
    {
      "id": "STU-LIJN-002",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "line_chart",
      "question": "Tussen welke twee maanden steeg de temperatuur het meest? Klik op de maand waar de stijging eindigde.",
      "context": null,
      "options": ["Maart", "Mei", "Juli", "September"],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Maart", "value": 8 },
          { "label": "Mei", "value": 16 },
          { "label": "Juli", "value": 24 },
          { "label": "September", "value": 18 }
        ],
        "correctIndex": 2,
        "xAxisLabel": "Maand",
        "yAxisLabel": "Temperatuur (°C)"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Stijging aflezen",
            "content": "Bereken het verschil tussen opeenvolgende punten. Maart→Mei: +8, Mei→Juli: +8, Juli→Sept: −6. De grootste stijging eindigt bij Juli.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "line_chart_steepest_rise",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "Strategie: bereken het verschil tussen opeenvolgende punten. Maart→Mei: 16−8 = +8. Mei→Juli: 24−16 = +8. Juli→Sept: 18−24 = −6 (daling). Beide stijgingen zijn gelijk (+8), maar de vraag vraagt waar de stijging eindigde — Juli is het eindpunt van de laatste stijging.",
        "distractorExplanations": {
          "0": "Maart is het beginpunt, niet het eindpunt van de stijging.",
          "1": "Mei is het eindpunt van de eerste stijging (Maart→Mei: +8), maar de stijging gaat door naar Juli.",
          "2": "Correct! Bij Juli eindigt de stijging (24°C) — daarna daalt de lijn.",
          "3": "September (18°C) is een daling ten opzichte van Juli, geen stijging."
        }
      }
    },
    {
      "id": "STU-LIJN-003",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "multiple_choice",
      "question": "Een lijndiagram toont het aantal bezoekers per dag: maandag 120, dinsdag 95, woensdag 140, donderdag 110. Wat is de trend?",
      "context": null,
      "options": ["Wisselend (op en neer)", "Stijgend", "Dalend", "Gelijk"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Trend herkennen",
            "content": "Kijk of de lijn stijgt, daalt, of op en neer gaat. 120→95 (daling), 95→140 (stijging), 140→110 (daling). De lijn gaat op en neer: wisselend.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "line_chart_trend",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Strategie: kijk naar de richting van de lijn. Stap 1: 120→95 = daling. Stap 2: 95→140 = stijging. Stap 3: 140→110 = daling. De lijn gaat afwisselend omhoog en omlaag: de trend is wisselend.",
        "distractorExplanations": {
          "0": "Correct! De lijn gaat op en neer (120→95→140→110), dus de trend is wisselend.",
          "1": "Niet stijgend — de lijn daalt ook (120→95 en 140→110).",
          "2": "Niet dalend — de lijn stijgt ook (95→140).",
          "3": "Niet gelijk — de waarden zijn allemaal verschillend."
        }
      }
    },
    {
      "id": "STU-LIJN-004",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "line_chart",
      "question": "Wanneer was het aantal verkochte ijsjes het laagst? Klik op het juiste punt.",
      "context": null,
      "options": ["Week 1", "Week 2", "Week 3", "Week 4"],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Week 1", "value": 50 },
          { "label": "Week 2", "value": 35 },
          { "label": "Week 3", "value": 80 },
          { "label": "Week 4", "value": 65 }
        ],
        "correctIndex": 1,
        "xAxisLabel": "Week",
        "yAxisLabel": "Aantal ijsjes"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Laagste punt zoeken",
            "content": "Zoek het laagste punt op de lijn. Week 2 (35) is het laagste punt.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "line_chart_lowest_point",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "Strategie: zoek het laagste punt. Week 1 (50), Week 2 (35), Week 3 (80), Week 4 (65). Het laagste punt is Week 2 met 35 ijsjes.",
        "distractorExplanations": {
          "0": "Week 1 (50) is niet het laagste. Week 2 (35) is lager.",
          "1": "Correct! Week 2 (35) is het laagste punt.",
          "2": "Week 3 (80) is juist het hoogste punt.",
          "3": "Week 4 (65) is hoger dan Week 2 (35)."
        }
      }
    },
    {
      "id": "STU-LIJN-005",
      "familyId": "STU-LIJN",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_lijndiagram",
      "questionType": "multiple_choice",
      "question": "Een lijndiagram toont de groei van een plant: week 1 = 2 cm, week 2 = 5 cm, week 3 = 9 cm, week 4 = 14 cm. Hoeveel centimeter groeide de plant tussen week 2 en week 4?",
      "context": null,
      "options": ["9 cm", "5 cm", "12 cm", "14 cm"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Verschil berekenen",
            "content": "Trek de waarde van week 2 af van week 4: 14 − 5 = 9 cm groei.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "line_chart_difference_calc",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Strategie: trek de beginwaarde af van de eindwaarde. Stap 1: Week 2 = 5 cm. Stap 2: Week 4 = 14 cm. Stap 3: Groei = 14 − 5 = 9 cm.",
        "distractorExplanations": {
          "0": "Correct! 14 − 5 = 9 cm groei tussen week 2 en week 4.",
          "1": "5 cm is de hoogte in week 2, niet de groei. Groei = 14 − 5 = 9 cm.",
          "2": "12 cm is de groei van week 1 tot week 4 (14 − 2 = 12). Maar de vraag gaat over week 2 tot week 4: 14 − 5 = 9 cm.",
          "3": "14 cm is de totale hoogte in week 4, niet de groei. Groei = 14 − 5 = 9 cm."
        }
      }
    }
  ]
}
